import { clean, format, validate } from "rut.js";

/** Valida un RUT chileno incluyendo su dígito verificador. */
export function isValidRut(value: string): boolean {
  return validate(value.trim());
}

/** Formato de presentación: 12.345.678-5. Mantiene texto incompleto para que la persona lo corrija. */
export function formatRut(value: string): string {
  const trimmed = value.trim();
  return trimmed && isValidRut(trimmed) ? format(trimmed) : trimmed.toUpperCase();
}

/** Formato canónico para almacenamiento y comparación: 12345678-5. */
export function normalizeRut(value: string): string {
  return format(clean(value), { dots: false });
}
